import React from "react";
import { useTranslation } from "react-i18next";
import Seo from "@/components/Seo";
import QuoteEstimator from "@/components/QuoteEstimator";
import { Phone, Mail, MapPin } from "lucide-react";

const QuotePage = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo titleKey="seo.quote_title" descKey="seo.quote_desc" path="/devis" />
      <section className="container-x pt-14 pb-10">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-blue">{t("nav.quote")}</p>
        <h1 className="mt-2 font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-slate-900">
          {t("quote.title")}
        </h1>
        <p className="mt-4 text-slate-600 text-base sm:text-lg max-w-3xl leading-relaxed">
          {t("quote.subtitle")}
        </p>
      </section>

      <section className="container-x pb-20 grid lg:grid-cols-12 gap-8 items-start">
        <div className="lg:col-span-8">
          <QuoteEstimator />
        </div>
        <aside className="lg:col-span-4 space-y-4 lg:sticky lg:top-28">
          <div className="rounded-3xl bg-white border border-slate-200 p-6 ring-soft">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-brand-blue">{t("nav.contact")}</div>
            <h3 className="mt-2 font-heading font-bold text-xl text-slate-900">{t("quote.sidebar_title")}</h3>
            <ul className="mt-4 space-y-3 text-sm text-slate-600">
              <li className="flex items-start gap-2">
                <Phone className="h-4 w-4 text-brand-blue mt-0.5" />
                <a href="tel:+33649502801" className="hover:text-brand-green">06 49 50 28 01</a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="h-4 w-4 text-brand-blue mt-0.5" />
                <a href="mailto:contact@bionet-solutions.com" className="hover:text-brand-green break-all">
                  contact@bionet-solutions.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-brand-blue mt-0.5" />
                <span>64 chemin de Sermenaz, 01700 Neyron</span>
              </li>
            </ul>
          </div>
          <div className="rounded-3xl bg-gradient-to-br from-emerald-50 to-sky-50 border border-slate-200 p-6">
            <div className="font-heading font-bold text-slate-900">{t("quote.sidebar_subtitle")}</div>
            <p className="text-sm text-slate-600 mt-1 leading-relaxed">
              Nos équipes étudient votre demande et vous proposent un devis personnalisé.
            </p>
          </div>
        </aside>
      </section>
    </>
  );
};

export default QuotePage;
